import {Doorbell} from "@variocube/app-api";
import {DoorbellMessageTypes, DoorBellRing} from "@variocube/driver-common";
import {VcmpClient} from "@variocube/vcmp";

export class ControllerDoorbell implements Doorbell {
	private readonly client: VcmpClient;

	constructor(url: string) {
		this.client = new VcmpClient(url, {autoStart: true});
	}

	async ring(doorBellSerialNr: string) {
		await this.client.send<DoorBellRing>({
			"@type": DoorbellMessageTypes.DoorbellRing,
			serialNumber: doorBellSerialNr,
		});
	}
}
